import { render, staticRenderFns } from "./xh-header.vue?vue&type=template&id=a0a2dfaa&scoped=true&"
import script from "./xh-header.vue?vue&type=script&lang=js&"
export * from "./xh-header.vue?vue&type=script&lang=js&"
import style0 from "./xh-header.vue?vue&type=style&index=0&id=a0a2dfaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a2dfaa",
  null
  
)

export default component.exports